/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import clsx from 'clsx'
import React from 'react'
import { UiStepsNavStep } from './UiStepsNav'

interface UiStepsNavItemsProps<StepId extends number> {
    activeStep: StepId
    maxReachedStep: StepId
    onSelect: (step: StepId) => void
    steps: UiStepsNavStep<StepId>[]
}

const UiStepsNavItems = <StepId extends number>(
    props: UiStepsNavItemsProps<StepId>
) => {
    return (
        <div className="UiStepsNavItems">
            {props.steps.map((step) => {
                const isActive = step.id === props.activeStep
                const isReachable = step.id <= props.maxReachedStep

                return (
                    <button
                        key={step.id}
                        type="button"
                        onClick={() => props.onSelect(step.id)}
                        disabled={!isReachable}
                        className={clsx(
                            'flex-1 rounded-full border px-3 py-2 transition-colors',
                            'border-gray-200 bg-white text-gray-600 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-200',
                            isReachable
                                ? 'hover:border-primary-400 hover:text-primary-600 dark:hover:border-primary-500 dark:hover:text-primary-300'
                                : 'opacity-50 cursor-not-allowed',
                            isActive &&
                                'border-primary-500 bg-primary-50 text-primary-700 dark:border-primary-400 dark:bg-primary-900/40 dark:text-primary-200'
                        )}
                    >
                        <span className={clsx('text-center w-full whitespace-nowrap')}>
                            {step.label}
                        </span>
                    </button>
                )
            })}
        </div>
    )
}

export default UiStepsNavItems
